/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  display: inline;
}

[internal-host] {
  color: var(--nve-sys-text-color, inherit);
}

slot {
  display: none;
}
